import React from 'react';
import styled from 'styled-components';
import {hover, hoverr, medium} from "@/styles/globalStyleVars";
import Link from "next/link";


const Button = ({
                    onSubmit,
                    text,
                    src,
                    img,
                    hoverImg,
                    fontSize,
                    fontWeight,
                    color,
                    letterSpacing,
                    lineHeight,
                    margin,
                    background,
                    borderRadius,
                    border,
                    width,
                    height,
                    hoverBackground,
                    target,
                    borderColor,
                    hoverColor,
                    svg,
                    hoverBorder,
                    href

                }) => {


    return (
        <StyledBtn className={`dc-btn fade-up`}
                   fontSize={fontSize}
                   fontWeight={fontWeight}
                   color={color}
                   background={background}
                   lineHeight={lineHeight}
                   letterSpacing={letterSpacing}
                   margin={margin}
                   border={border}
                   img={img}
                   borderRadius={borderRadius}
                   width={width}
                   hoverImg={hoverImg}
                   hoverBackground={hoverBackground}
                   height={height}
                   borderColor={borderColor}
                   target={target}
                   hoverColor={hoverColor}
                   onSubmit={onSubmit}
                   svg={svg}
                   hoverBorder={hoverBorder}

        >
            {src ? (
                <Link href={src || '/'}>
                    <span> {text}  </span>
                </Link>
            ) :
                href ? (
                    <a href={href ? href : ''} target={target || '_self'}>
                        <span>{text}</span>
                        <div>{svg}</div>
                    </a>
                ) :
                    (
                        <a href={"#"} >
                            <span>{text}</span>
                            <div>{svg}</div>
                        </a>
                    )
            }
        </StyledBtn>
    )
};

const StyledBtn = styled.div`
    will-change: transform;

    &.dc-btn {
        margin: ${props => props.margin || '0'};
        width: ${props => props.width || '100%'};
        height: ${props => props.height || '48'}px;
        //cursor: pointer;
        will-change: transform;


        a {
            display: flex;
            width: ${props => props.width || 'fit-content'};
            height: 100%;
            align-items: center;
            justify-content: center;
            font-size: ${props => props.fontSize || '14'}px;
            font-weight: ${props => props.fontWeight || 500};
            //line-height: 16px;
            margin: 0;
            line-height: ${props => props.lineHeight || '16'}px;
            background-color: ${props => props.background || `transparent`};
            position: relative;
            border-radius: ${props => props.borderRadius || '30'}px;
            overflow: hidden;
            z-index: 0;
            transition: border 1s cubic-bezier(.25, .74, .22, .99);
            padding: ${props => props.padding || `16px 32px`};
            box-sizing: border-box;
            border: ${props => props.border || `none`};
            border-color: ${props => props.borderColor || `transparent`};
            border-style: ${props => props.border ? 'solid' : `transparent`};

            span {
                transition: all 1s cubic-bezier(.25, .74, .22, .99);
                color: ${props => props.color || `#FFFFFF`};
                position: relative;
                z-index: 2;

                //top: 2px;

                //line-height: 45px;

                svg {
                    margin-right: 8px;

                    line {
                        transition: all 1s cubic-bezier(.25, .74, .22, .99);
                    }

                    path {
                        transition: all 1s cubic-bezier(.25, .74, .22, .99);
                    }
                }
            }

            &:before {
                bottom: 0;
                content: "";
                display: block;
                position: absolute;
                right: 0;
                top: 0;
                left: 0;
                background-color: ${p => p.hoverBackground || '#3C3C3B'};
                height: 100%;
                width: 100%;
                margin: auto;
                transition: all 1s cubic-bezier(.25, .74, .22, .99);
                border-radius: 24px;
                transform: scale(0); // Updated to start from center
                transform-origin: center; // Set the transform origin to the center
            }

            &:hover {
                    //border-color: ${hover};
                // border-color: ${props => props.hoverBorder || `transparent`};

                span {
                    // color: ${props => props.hoverColor || `#FFF`};
                }

                svg {
                    line {
                        stroke: ${props => props.hoverColor || '#FFF'};
                    }

                    path {
                        fill: ${props => props.hoverColor || '#FFF'};
                    }
                }

                &:before {
                    transform: scale(1); // Updated to expand to cover the whole button
                }
            }

            &:focus {
                color: #222222;
            }
        }
    }

`;


export default React.memo(Button);
